import { List } from '@hai/ui-react';
import React, { useEffect } from 'react';
import { SortDirection, SortManager } from 'src/js/component/sort-manager';
import { scrollPanelIntoView } from 'src/js/component/actionBar/streaming-action-bar';
import { constant } from 'src/js/constant';

import { MetadataViewModel } from './metadata-models';
import { MetadataRow } from './metadata-row';

interface MetadataProps {
  list: MetadataViewModel[];
  direction: SortDirection;
  sorting: string;
  onSelect: (model: MetadataViewModel, selected: boolean) => void;
  sortInfo: any;
  scrollToId?: string | number;
}

export const MetadataList: React.FunctionComponent<MetadataProps> = ({
  list,
  direction,
  sorting,
  onSelect,
  scrollToId,
  sortInfo,
}) => {
  useEffect(() => {
    scrollPanelIntoView({ id: scrollToId });
  }, []);

  return (
    <List accentColor={constant.productColor}>
      <SortManager sortInfo={sortInfo} list={list} sortKey={sorting} direction={direction} secondLevelSortKey="name">
        {list &&
          list.map((model: MetadataViewModel) => {
            return <MetadataRow key={model.id} model={model} onSelect={onSelect} scrollToId={scrollToId} />;
          })}
      </SortManager>
    </List>
  );
};
